import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Checkmark",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_5670",
		"data-name": "Path 5670",
		d: "M0,0H24V24H0Z",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12446",
		"data-name": "Path 12446",
		d: "M868.95-53.706l4.837,4.837,11.169-11.17",
		transform: "translate(-864.953 66.453)",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	})]
});
export default SvgCheckmark;
